export const scrollPageToTop = () => {
  const pageElement = document.querySelector('body > .page');
  if (pageElement) {
    pageElement.scrollTop = 0;
  }
  document.body.scrollTop = document.documentElement.scrollTop = 0;
};